import { setElements } from '../setElements'
import { setLoading } from '../setLoading'
import { SidebarUsersApi } from '../../api'

export const fetchUsers = ({ page, limit, types }) => async dispatch => {
  console.log('listsidebar fetchusers', page, limit, types)
  try {
    dispatch(setLoading(true))
    const api = new SidebarUsersApi()
    const users = await api.getUsers(page, limit, types)
    if (!users.error && Array.isArray(users)) {
      dispatch(setElements(users))
    } else {
      dispatch(setElements(null))
    }
    dispatch(setLoading(false))
  } catch (e) {
    dispatch(setElements(null))
    dispatch(setLoading(false))
    return { error: e.message }
  }
}
